import { IPersonalNote, IPersonalNoteUpdate } from '../../resource/personal-note/personal-note.types';
import { IApiRequestConfig } from '../api.types';

export const getPersonalNotesApi = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getPersonalNotes',
  uri: 'json',
  action: 'self/notes',
  method: 'get',
  v2: true,
});

export const createPersonalNoteApi = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'createPersonalNote',
  uri: 'json',
  action: 'self/notes',
  method: 'post',
  v2: true,
});

export const updatePersonalNoteApi = (
  noteId: IPersonalNote['id'],
  note: IPersonalNoteUpdate,
): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'updatePersonalNote',
  uri: 'json',
  action: `self/notes/${noteId}`,
  method: 'patch',
  data: note,
  v2: true,
});

export const deletePersonalNoteApi = (noteId: IPersonalNote['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'deletePersonalNote',
  uri: 'json',
  action: `self/notes/${noteId}`,
  method: 'delete',
  v2: true,
});
